import objectHash from 'object-hash';

// eslint-disable-next-line
export const getHashFromObject = (data: any): string => {
  return objectHash(JSON.parse(JSON.stringify(data)));
};
